import { useContext, useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import { User } from "lucide-react";
import logo from "../assets/logo.png";

export default function Navbar() {
  const { isLoggedIn, logout, user } = useContext(AuthContext);
  const navigate = useNavigate();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(e.target as Node)
      ) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () =>
      document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const upgradeLabel =
    user?.plan === "free"
      ? "Upgrade to Pro"
      : user?.plan === "pro"
      ? "Upgrade to Premium"
      : null;

  return (
    <nav className="sticky top-0 z-40 border-b border-slate-200/80 bg-white/90 backdrop-blur-md">
      <div className="section-wrap flex flex-wrap items-center justify-between gap-3 py-3">
        <button
          className="flex items-center gap-3 rounded-xl px-2 py-1 transition hover:bg-slate-100"
          onClick={() => navigate("/")}
        >
          <img
            src={logo}
            alt="DeCipher Logo"
            className="h-10 w-10 rounded-lg object-contain"
          />
          <span className="text-xl font-bold tracking-tight text-secondary sm:text-2xl">
            DeCipher
          </span>
        </button>

        {isLoggedIn ? (
          <div className="ml-auto flex items-center gap-2 sm:gap-3">
            {upgradeLabel && (
              <button
                onClick={() => navigate("/pricing")}
                className="btn-primary whitespace-nowrap px-3 py-2 text-xs sm:px-4 sm:text-sm"
              >
                {upgradeLabel}
              </button>
            )}

            <div className="relative" ref={dropdownRef}>
              <button
                onClick={() => setDropdownOpen((v) => !v)}
                className="flex h-10 w-10 items-center justify-center rounded-full border border-slate-300 bg-white text-secondary transition hover:border-primary/50 hover:bg-slate-100"
                aria-label="Open account menu"
              >
                <User size={18} />
              </button>

              {dropdownOpen && (
                <div className="ui-card absolute right-0 mt-2 w-52 overflow-hidden py-1">
                  <button
                    className="w-full px-4 py-2.5 text-left text-sm font-medium text-secondary transition hover:bg-slate-100"
                    onClick={() => {
                      setDropdownOpen(false);
                      navigate("/account");
                    }}
                  >
                    Manage Account
                  </button>
                  <button
                    className="w-full px-4 py-2.5 text-left text-sm font-medium text-danger transition hover:bg-red-50"
                    onClick={logout}
                  >
                    Logout
                  </button>
                </div>
              )}
            </div>
          </div>
        ) : (
          <div className="ml-auto flex items-center gap-2">
            <button className="btn-secondary px-3 py-2 text-xs sm:px-4 sm:text-sm" onClick={() => navigate("/login")}>
              Login
            </button>
            <button className="btn-primary px-3 py-2 text-xs sm:px-4 sm:text-sm" onClick={() => navigate("/register")}>
              Register
            </button>
          </div>
        )}
      </div>
    </nav>
  );
}
